module.exports = __webpack_public_path__ + "assets/engineering-d0e1da2a7b1b599e7cb1e42b5aeadc31.svg";